<!-- Main Content - No sidebar, just the router outlet -->
<main class="app-main">
  <!-- Header - Only show when authenticated and not on auth pages -->
@if (isAuthenticated() && !isAuthPage()) {
  <app-header 
    [config]="{
      showLogo: true,
      showNavigation: true,
      showUserMenu: true,
      showSearch: false,
      showNotifications: false,
      variant: 'default'
    }"
    (menuItemClicked)="onHeaderMenuItemClick($event)"
    (userMenuAction)="onHeaderUserMenuAction($event)"
  ></app-header>
}
  <router-outlet />
  @if (cookieConsent.enabled) {
    <footer class="app-footer" [class.app-footer--over-auth]="isAuthPage()">
      <button type="button" class="app-footer__link" (click)="cookieConsent.openSettings()">Definições de cookies</button>
    </footer>
  }
</main>
@if (isAuthenticated() && !isAuthPage()) {
  <!-- Both show patient data (Clarity masking, ADO ezfy #89). -->
  <app-ana-assistant data-clarity-mask="true" />
  <app-contactar-utente-panel data-clarity-mask="true" />
}
<app-snackbar />
<app-cookie-banner />
